import { motion } from "framer-motion";
import { Bolt, Coins, Layers, Megaphone } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 19 — Now · the flip. Three "abundance" rows + the new agent thought:
 * "Post EVERYTHING. Everywhere."
 */

const now = [
  { icon: Coins, label: "Editing cost", value: "= low cost" },
  { icon: Bolt, label: "Turnaround", value: "= instant" },
  { icon: Layers, label: "Variations", value: "= unlimited" },
];

export default function Scene19_Now() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-now">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        style={{
          background:
            "radial-gradient(ellipse at 30% 50%, rgba(150,193,31,0.22) 0%, transparent 55%)",
        }}
      />

      <div className="relative max-w-[1400px] mx-auto w-full grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <motion.h2
            initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
            animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            transition={{ duration: 1.0, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="kn-display text-5xl sm:text-6xl lg:text-7xl text-white"
            data-testid="now-title"
          >
            Now,{" "}
            <span style={{ color: "#96C11F" }}>video is</span>
            <br />
            <span
              style={{
                background:
                  "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              everywhere.
            </span>
          </motion.h2>

          <ul className="mt-12 space-y-5">
            {now.map((n, i) => {
              const Icon = n.icon;
              return (
                <motion.li
                  key={n.label}
                  initial={{ opacity: 0, x: -16 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{
                    delay: 0.7 + i * 0.18,
                    duration: 0.7,
                    ease: [0.16, 1, 0.3, 1],
                  }}
                  className="flex items-center gap-5"
                  data-testid={`now-row-${i}`}
                >
                  <span
                    className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0"
                    style={{
                      background: "rgba(150,193,31,0.18)",
                      color: "#96C11F",
                      border: "1px solid rgba(150,193,31,0.45)",
                    }}
                  >
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="text-xl sm:text-2xl text-white">
                    {n.label}
                  </span>
                  <span
                    className="text-xl sm:text-2xl font-semibold"
                    style={{ color: "#96C11F" }}
                  >
                    {n.value}
                  </span>
                  {n.note ? (
                    <span className="text-sm text-white/55 italic">
                      {n.note}
                    </span>
                  ) : null}
                </motion.li>
              );
            })}
          </ul>
        </div>

        {/* The flipped behaviour callout */}
        <div className="lg:col-span-6 flex flex-col items-center justify-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 16 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 1.0, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
            data-testid="now-thought"
          >
            <div
              className="rounded-3xl px-10 py-10 text-center max-w-lg"
              style={{
                background: "rgba(150,193,31,0.12)",
                border: "1px solid rgba(150,193,31,0.45)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 0 80px rgba(150,193,31,0.20)",
              }}
            >
              <Megaphone
                className="w-8 h-8 mx-auto mb-4"
                style={{ color: "#96C11F" }}
              />
              <div
                className="kn-display text-3xl sm:text-4xl lg:text-5xl"
                style={{ color: "#e2e8f0", lineHeight: 1.05, fontWeight: 800 }}
              >
                "We want{" "}
                <span style={{ color: "#96C11F" }}>video</span>
                <br />
                on{" "}
                <span
                  style={{
                    background:
                      "linear-gradient(135deg, #96C11F 0%, #00deb6 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent",
                  }}
                >
                  everything.
                </span>
                "
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </SceneShell>
  );
}
